import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/auth';
import { ShippingObjectTypes } from '../../state.js';
import { seedShippingForm } from './seed-shipping-form.js';

// These source data form names are different from the checkout form names
const mappingCartForms = {
    [ShippingObjectTypes.ContactDetails]: 'customer'
};
const mappingMyAccountData = {
    [ShippingObjectTypes.ContactDetails]: Types.FormName.personalDetails
};
const formIsTouched = (formDataFields)=>{
    for (const field of Object.values(formDataFields || {})){
        if (field === null || field === void 0 ? void 0 : field.isTouched) return true;
    }
    return false;
};
var mapShippingFormsUpdate = ({ cartData , userData , fields  }, shippingDetails)=>{
    const result = {};
    // Attempt to prefill all shipping forms from cart and my-account sources
    for(const _ref in ShippingObjectTypes){
        var key = _ref;
        var ref, ref1;
        const formName = ShippingObjectTypes[key];
        // Redux form state is rehydrated from session storage, if any of the fields were touched, do not attempt prefill
        if (formIsTouched(shippingDetails === null || shippingDetails === void 0 ? void 0 : (ref = shippingDetails[formName]) === null || ref === void 0 ? void 0 : ref.formData)) continue;
        const userDataResult = userData.status === 'success' ? userData.result : undefined;
        const formFields = fields === null || fields === void 0 ? void 0 : fields[formName];
        const cartDataForm = cartData === null || cartData === void 0 ? void 0 : cartData[mappingCartForms[formName] || formName];
        const myAccountData = userDataResult === null || userDataResult === void 0 ? void 0 : userDataResult[mappingMyAccountData[formName] || formName];
        // Data that was already filled in by the user and saved to the cart should take precedence over my account data
        const inputForm = cartDataForm || myAccountData;
        // No prefill data found, or missing form field configuration
        if (!inputForm || !formFields) continue;
        let formValues = inputForm;
        if (inputForm && formName === ShippingObjectTypes.BillingAddress && 'countryCode' in inputForm) {
            // Rename countryCode to country for billing address form
            const { countryCode  } = inputForm, rest = swcHelpers.objectWithoutProperties(inputForm, [
                "countryCode"
            ]);
            formValues = swcHelpers.objectSpread({}, rest, {
                country: countryCode
            });
        } else if (formName === 'contactDetails' && !formValues.email && (userDataResult === null || userDataResult === void 0 ? void 0 : userDataResult.email)) {
            // Email is missing from the personalDetails object in userData but available directly on the user data
            formValues = swcHelpers.objectSpread({}, inputForm, {
                email: userDataResult.email
            });
        }
        // Prepopulate `customerVatId` with `ssn` from personal details object
        if (formName === 'contactDetails' && (userDataResult === null || userDataResult === void 0 ? void 0 : (ref1 = userDataResult.personalDetails) === null || ref1 === void 0 ? void 0 : ref1.ssn)) {
            var ref2;
            formValues = swcHelpers.objectSpread({}, formValues, {
                customerVatId: userDataResult === null || userDataResult === void 0 ? void 0 : (ref2 = userDataResult.personalDetails) === null || ref2 === void 0 ? void 0 : ref2.ssn
            });
        }
        const shippingForm = seedShippingForm(formFields, formValues, shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails[formName]);
        if (shippingForm) {
            result[formName] = shippingForm;
        }
    }
    return result;
};

export { mapShippingFormsUpdate };
//# sourceMappingURL=map-shipping-forms-update.js.map
